// Platform / super-admin login. Distinct from staff login — different
// session-storage key, different API path, different post-login route.

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePlatformAuth } from '../lib/platformAuth.jsx';

export default function PlatformLogin() {
  const { login } = usePlatformAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('admin@platform.local');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      await login(email, password);
      nav('/platform', { replace: true });
    } catch (e) { setErr(e.body?.message || e.message); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-slate-900 text-slate-100">
      <form onSubmit={submit} className="w-full max-w-sm bg-slate-800 rounded-lg border border-slate-700 p-6 space-y-4">
        <div>
          <div className="text-xs uppercase tracking-wide text-amber-400 font-semibold mb-1">Platform admin</div>
          <h1 className="text-xl font-bold">Meds-to-Beds — super-admin</h1>
          <p className="text-sm text-slate-400">Tenant management + global ops only. Not for hospital staff.</p>
        </div>
        <div>
          <label className="block text-xs font-medium mb-1">Email</label>
          <input className="w-full rounded bg-slate-900 border border-slate-700 p-2 text-slate-100"
            value={email} onChange={e => setEmail(e.target.value)} autoComplete="username" />
        </div>
        <div>
          <label className="block text-xs font-medium mb-1">Password</label>
          <input type="password" className="w-full rounded bg-slate-900 border border-slate-700 p-2 text-slate-100"
            value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" />
        </div>
        {err && <div className="text-sm text-red-400">{err}</div>}
        <button className="w-full py-2 rounded bg-amber-500 text-slate-900 font-medium hover:bg-amber-400 disabled:opacity-50"
          disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        <div className="text-xs text-slate-500 pt-2 border-t border-slate-700">
          Bootstrap account: <span className="font-mono">admin@platform.local</span> /
          <span className="font-mono"> change-me-on-first-login</span>. Rotate immediately.
        </div>
      </form>
    </div>
  );
}
